<template>
    <div class="result-message">
        <p>
            {{resultMessage.message}}
            <a
                v-if="resultMessage.redirect=='home'"
                class="action"
                :href="redirect"
            >
                {{ $t(`subscription.messages.login_required.${resultMessage.redirect}`) }}
            </a>
            
            <router-link
                v-else-if="resultMessage.redirect"
                class="action"
                :to="{ name: resultMessage.redirect }"
            >
                {{ $t(`subscription.messages.login_required.${resultMessage.redirect}`) }}
            </router-link>

        </p>
    </div>
</template>
<script>
export default {
    name: 'ResultMessage',
    props: {
        resultMessage: {}
    },
    computed: {
        redirect(){
            return (this.resultMessage && this.resultMessage.plan_id)
                        ? '/subscribe?plan=' + this.resultMessage.plan_id
                        : '/home';
        }
    }
}
</script>
<style scoped lang="scss">
@import './../styles/variables';
@import './../styles/classes';

.result-message {
    text-align: center;
    border-radius: 3px;
    padding: 5px;
    margin: 5px 0 10px 0;
    background: #fafaff;
    color: $pallete_main_color;
    a{
        text-decoration: underline;
        font-weight: bold;
    }
}
</style>